import React from 'react';
import { Chip, alpha } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { OrderType } from '../../types';
import { palette, typography, theme as themeConfig } from '../../theme/colors';

interface OrderTypeBadgeProps {
  orderType: OrderType;
  size?: 'small' | 'medium';
}

interface TypeConfig {
  color: string;
  label: string;
  icon: React.ReactElement;
}

const getOrderTypeConfig = (orderType: OrderType): TypeConfig => {
  switch (orderType) {
    case OrderType.B2C:
      return {
        color: palette.primary,
        label: 'B2C',
        icon: <PersonIcon sx={{ fontSize: 16 }} />,
      };
    case OrderType.B2B_DIRECT:
      return {
        color: palette.accent,
        label: 'B2B DIRECT',
        icon: <BusinessIcon sx={{ fontSize: 16 }} />,
      };
    case OrderType.B2B_QUOTE:
      return {
        color: palette.info,
        label: 'B2B DEVIS',
        icon: <RequestQuoteIcon sx={{ fontSize: 16 }} />,
      };
    default:
      return {
        color: palette.textMuted,
        label: String(orderType).toUpperCase(),
        icon: <ShoppingCartIcon sx={{ fontSize: 16 }} />,
      };
  }
};

export const OrderTypeBadge: React.FC<OrderTypeBadgeProps> = ({
  orderType,
  size = 'small'
}) => {
  const config = getOrderTypeConfig(orderType);

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size={size}
      sx={{
        backgroundColor: alpha(config.color, 0.1),
        color: config.color,
        fontFamily: typography.fontFamily.mono,
        fontSize: typography.fontSize.xs,
        fontWeight: typography.fontWeight.bold,
        border: `1px solid ${config.color}`,
        textTransform: 'uppercase',
        borderRadius: themeConfig.radius.sm,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
    />
  );
};

export default OrderTypeBadge;
